import React from "react";
import Translate from "../../helpers/translate";

function RearrangeItem({
  page,
  order,
  onDragStart,
  onDrop
}) {
  return /*#__PURE__*/React.createElement("div", {
    key: page,
    draggable: true,
    onDragStart: onDragStart,
    onDrop: onDrop,
    onDragOver: e => e.preventDefault(),
    "item-id": order,
    className: "react__pdf--rearrange-modal-box-body-item mb-10"
  }, /*#__PURE__*/React.createElement("i", {
    onDragOver: e => e.preventDefault(),
    "item-id": order,
    className: "fas fa-bars"
  }), /*#__PURE__*/React.createElement("div", {
    onDragOver: e => e.preventDefault(),
    "item-id": order,
    className: "react__pdf--rearrange-modal-box-body-item-label"
  }, Translate({
    id: "page"
  }), " ", page), /*#__PURE__*/React.createElement("div", null));
}

export default RearrangeItem;